import { useUserData } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { UserMenuAvatar } from '../UserAvatar'
import { UserMenuName } from '../UserMenuName'

import { QA_NAME_USER_MENU } from './UserMenu.constants'

import * as styles from './UserMenu.module.css'

function UserMenu({ AccountLinks, className = styles.UserMenu, ref }) {
  const { avatar, avatar_color, fullname, id } = useUserData()

  const qaProps = getQaSelector({ value: QA_NAME_USER_MENU })

  return (
    <div {...qaProps} className={className} ref={ref}>
      <UserMenuAvatar
        avatar={avatar}
        avatarColor={avatar_color}
        fullname={fullname}
      />
      <UserMenuName
        AccountLinks={AccountLinks}
        fullname={fullname}
        owner={id}
      />
    </div>
  )
}

export default UserMenu
